<template>
    <div class="bg-round bg-fff" >
        <div class="container">
            <el-steps :active="3" simple  finish-status="success" class="ma-tb-40">
        <el-step title="登录"></el-step>
        <el-step title="选择参赛"></el-step>
        <el-step title="参赛联系人"></el-step>
        <el-step title="确认付款"></el-step>
      </el-steps>
        </div>

        <!-- <div id="loading-box">
            加载中
        </div> -->

        <div class="container" id="app">
            <div class="form" v-cloak>
                <div class="t-center" v-show="!PayStase">
                    <div class="bold">报名金额：<span class="fon-20 c-red">{{payRep.Amount}}元</span></div>
                    <div id="qrcodeDiv" class="mt-10"></div>
                    <div class="mt-10">微信扫码支付</div>
                    <div class="btn-last ma-lr-auto mt-50 c-pointer" @click="last">上一步</div>
                </div>
                <div class="t-center" v-show="PayStase">
                    <h2 class="bold">支付成功</h2>
                    <div>
                        <i class="iconfont icon-chenggong icon-success"></i>
                    </div>

                    <a @click="toPage('mycompetition')" class="a-btn ma-lr-auto c-pointer mt-10">上传报名资料</a>
                    <div>如在报名与提交过程中遇到任何问题，请发送邮件至shishortweek@hotmail.com，我们会及时回复您。</div>
                </div>
            </div>
        </div>

        
        <div class="img-a-bg">
            <img src="../../img/merge/i2.png" alt="" srcset="" class="img-logo c-pointer" onclick="location.href='http://www.shisw.net/'">
        </div>
        
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    
    @media (max-width:768px) {
        .img-a-bg{
            display:none;
        }
    }
    .img-a-bg {
        width: 100%;
        height: 285px;
        background: url('../../img/merge/a1.png') no-repeat;
        background-size: cover;
        background-position: center center;
        text-align: right;
        line-height: 285px;
    }

    .img-logo {
        width: 206px;
        height: 206px;
        margin-right: 40px;
    }

    .btn-last,
    .a-btn {
        width: 300px;
        height: 50px;
        line-height: 50px;
        color: #FB004D;
        border-radius: 10px;
        text-align: center;
        border: 1px solid #FB004D;

        margin: 20px auto;

    }

    .a-btn {
        color: #FB004D;
        display: block;
        text-decoration: none;
    }

    .a-btn:hover {
        color: #FB004D;
    }

    #qrcode {
        display: flex;
        justify-content: center;
    }

    .icon-success {
        font-size: 100px;
        color: #52c41a;
    }

    @media (min-width: 768px) {
        .form {
            border-radius: 10px;
            width: 500px;
            padding: 40px;
            box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.35);
            margin: 0 auto;
        }
    }

    @media (max-width: 768px) {
        .form {
            border-radius: 10px;
            width: 100%;
            padding: 20px;
            box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.35);
            margin: 0 auto;
        }
    }
    #qrcodeDiv{
        width: 128px;
        margin: 1rem auto;
    }

    [v-cloak] {
        display: none;
    }
</style>
<script>
    import {orderPay,PayResult} from "../../api.js";
    import QRCode from "qrcodejs2";
    import wx from "weixin-js-sdk";
    export default {
        name: "merge",
        data() {
            return {
                form: {
                    Key: null,
                    Type: 'weixin',
                    Token: localStorage.getItem('AccessToken')
                },
                payRep: {},//发起支付返回值
                PayStase: false,//支付结果
                showPage: false,
                interval:null,
                Qrcode:"",
                footbottom:123,
            };
        },
        activated() {
            console.log("开始开发")
            this.form.Key = localStorage.getItem('orderKey');
            this.getorderPay();
        },
        methods: {
            //获取支付数据
            getorderPay() {
                orderPay(this.form).then((res) => {
                    console.log("122",res);
                    this.payRep = res.data.Data;
                    this.Qrcode = res.data.Data.Qrcode;

                    let qrcodeDiv = document.getElementById("qrcodeDiv");
                    qrcodeDiv.innerHTML = "";
                    var qrcode = new QRCode(qrcodeDiv, {
                        text: "http://jindo.dev.naver.com/collie",
                        width: 128,
                        height: 128,
                        colorDark: "#000000",
                        colorLight: "#ffffff",
                        correctLevel: QRCode.CorrectLevel.H,
                    });
                    qrcode.makeCode(this.Qrcode);
                    this.getPayState();
                });
            },
            //监听支付结果
            getPayState() {
                this.interval = setInterval(() => {
                    var data={
                        Token: localStorage.getItem('AccessToken'),
                        PayId: this.payRep.PayId
                    }
                    PayResult(data).then((result) => {
                        if (result.data.Data) {
                            this.PayStase = result.data.Data
                            clearInterval(this.interval);
                        }
                    });
                }, 1500);
            },
            //微信内支付
            wxPay(weixin) {
                wx.config({
                    debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                    appId: weixin.AppId, // 必填，公众号的唯一标识
                    timestamp: weixin.TimeStamp, // 必填，生成签名的时间戳
                    nonceStr: weixin.NonceStr, // 必填，生成签名的随机串
                    signature: weixin.PaySign, // 必填，签名
                    jsApiList: ["chooseWXPay"], // 必填，需要使用的 JS 接口列表
                });
                wx.ready(function () {
                    //发起微信支付
                    wx.chooseWXPay({
                        timestamp: weixin.TimeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                        nonceStr: weixin.NonceStr, // 支付签名随机串，不长于 32 位
                        package: weixin.Package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: weixin.SignType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                        paySign: weixin.PaySign, // 支付签名
                        success: function (res) {
                            // 支付成功后的回调函数
                            this.PayStase = res.data.Data
                            clearInterval(this.interval);
                        },
                    });
                });
            },
            switchItem(id) {
                let i = this.activeIds.indexOf(id)
                if (i == -1) {
                    this.activeIds.push(id)
                } else {
                    this.activeIds.splice(i, 1)

                }
            },
            toPage(url){
                this.$router.push("/merge/"+url);
            },
            //上一步
            last() {
                clearInterval(this.interval);
                console.log(this.interval)
                this.$router.push("/competition/apply");
            },
        },
    };
</script>
